(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react")) : factory(root["react"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_react__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./packages/text-input/src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./packages/text-input/src/TextInput.tsx":
/*!***********************************************!*\
  !*** ./packages/text-input/src/TextInput.tsx ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(/*! react */ "react"));
var utilities_1 = __webpack_require__(/*! @hsl-fi/utilities */ "@hsl-fi/utilities");
var text_input_label_1 = __importDefault(__webpack_require__(/*! @hsl-fi/text-input-label */ "@hsl-fi/text-input-label"));
var text_input_field_1 = __importDefault(__webpack_require__(/*! @hsl-fi/text-input-field */ "@hsl-fi/text-input-field"));
var text_input_error_1 = __importDefault(__webpack_require__(/*! @hsl-fi/text-input-error */ "@hsl-fi/text-input-error"));
var TextInput = function (_a) {
    var autocapitalize = _a.autocapitalize, autocomplete = _a.autocomplete, autocorrect = _a.autocorrect, autofocus = _a.autofocus, spellcheck = _a.spellcheck, _b = _a.type, type = _b === void 0 ? 'search' : _b, maxLength = _a.maxLength, label = _a.label, value = _a.value, tabIndex = _a.tabIndex, placeholder = _a.placeholder, onChange = _a.onChange, onEnter = _a.onEnter, onFocus = _a.onFocus, onBlur = _a.onBlur, hideLabel = _a.hideLabel, clear = _a.clear, className = _a.className, disabled = _a.disabled, required = _a.required, hasError = _a.hasError, errorText = _a.errorText, errorChildren = _a.errorChildren, onKeyDown = _a.onKeyDown, _c = _a.variant, variant = _c === void 0 ? 'medium' : _c;
    var classList = utilities_1.PropertyUtilities.classList;
    var generateId = utilities_1.TextUtilities.generateId;
    var errorId = generateId("error-" + label);
    return (react_1.default.createElement("div", { className: classList(className && className) },
        !hideLabel && (react_1.default.createElement(text_input_label_1.default, { label: label, required: required, disabled: disabled, variant: variant })),
        react_1.default.createElement(text_input_field_1.default, { autocapitalize: autocapitalize, autocomplete: autocomplete, autocorrect: autocorrect, autofocus: autofocus, spellcheck: spellcheck, type: type, maxLength: maxLength, label: label, value: value, tabIndex: tabIndex, placeholder: placeholder, onChange: onChange, onEnter: onEnter, onFocus: onFocus, onBlur: onBlur, clear: clear, disabled: disabled, required: required, hasError: hasError, errorId: errorId, variant: variant, onKeyDown: onKeyDown }),
        react_1.default.createElement("span", { id: errorId },
            react_1.default.createElement(text_input_error_1.default, { visible: hasError, text: errorText }, errorChildren))));
};
exports.default = TextInput;


/***/ }),

/***/ "./packages/text-input/src/index.ts":
/*!******************************************!*\
  !*** ./packages/text-input/src/index.ts ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TextInput_1 = __importDefault(__webpack_require__(/*! ./TextInput */ "./packages/text-input/src/TextInput.tsx"));
__exportStar(__webpack_require__(/*! ./types */ "./packages/text-input/src/types.ts"), exports);
exports.default = TextInput_1.default;


/***/ }),

/***/ "./packages/text-input/src/types.ts":
/*!******************************************!*\
  !*** ./packages/text-input/src/types.ts ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),

/***/ "@hsl-fi/text-input-error":
/*!*******************************************!*\
  !*** external "@hsl-fi/text-input-error" ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@hsl-fi/text-input-error");

/***/ }),

/***/ "@hsl-fi/text-input-field":
/*!*******************************************!*\
  !*** external "@hsl-fi/text-input-field" ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@hsl-fi/text-input-field");

/***/ }),

/***/ "@hsl-fi/text-input-label":
/*!*******************************************!*\
  !*** external "@hsl-fi/text-input-label" ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@hsl-fi/text-input-label");

/***/ }),

/***/ "@hsl-fi/utilities":
/*!************************************!*\
  !*** external "@hsl-fi/utilities" ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@hsl-fi/utilities");

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ });
});
//# sourceMappingURL=index.js.map